var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { State } from "../../../hooks/useUseCase";
import { DrillType, Subject } from "../constants/drill";
import { WorkTemplateGroups } from "../models/WorkTemplate/WorkTemplateGroups";
/**
 * 「テンプレート」タブの状態
 */
var WorkTemplateTabState = /** @class */ (function (_super) {
    __extends(WorkTemplateTabState, _super);
    function WorkTemplateTabState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // ワークテンプレートグループ
        _this.templateGroups = new WorkTemplateGroups();
        // ドリルタイプ
        _this.drillTypes = [DrillType.KOKUGO];
        // 学年
        _this.grade = 1;
        // 教科
        _this.subject = Subject.KOKUGO;
        // コース一覧
        _this.courseList = [];
        // ロード中であるか
        _this.isLoading = false;
        // エラーが発生したか
        _this.hasError = false;
        // 初期化済みか
        _this.initialized = false;
        return _this;
    }
    Object.defineProperty(WorkTemplateTabState.prototype, "currentTemplateGroupsKey", {
        // 現在表示されるワークテンプレートグループのキー
        //
        // ※ 配列やタプルをMapのキーにすると正しく動作しないので文字列化する
        get: function () {
            return JSON.stringify([this.drillTypes, this.grade]);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WorkTemplateTabState.prototype, "currentTemplateGroups", {
        // 現在表示されるワークテンプレートグループ
        get: function () {
            return this.templateGroups.get(this.currentTemplateGroupsKey);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WorkTemplateTabState.prototype, "allTemplates", {
        // 全てのワークテンプレート
        get: function () {
            return this.templateGroups.allTemplates;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WorkTemplateTabState.prototype, "selectedTemplates", {
        // 選択したワークテンプレート
        get: function () {
            return this.templateGroups.selectedTemplates;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WorkTemplateTabState.prototype, "selectedCount", {
        // 選択したワークテンプレートの数
        get: function () {
            return this.templateGroups.selectedCount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WorkTemplateTabState.prototype, "selectedCourseIds", {
        // 選択されている学年・教科に対応するコースID
        get: function () {
            var _this = this;
            return this.drillTypes.reduce(function (acc, drillType) {
                var targetCourse = _this.courseList.find(function (course) {
                    return course.grade === _this.grade && course.drillType === drillType;
                });
                return targetCourse == null ? acc : __spreadArrays(acc, [targetCourse.id]);
            }, []);
        },
        enumerable: false,
        configurable: true
    });
    WorkTemplateTabState.prototype.reduce = function (payload) {
        switch (payload.type) {
            case 'InitializedPayload':
                this.onInitialized(payload);
                break;
            case 'LoadedWorkTemplateGroupsPayload':
                this.onWorkTemplateGroupsLoaded(payload);
                break;
            case 'ChangedGradePayload':
                this.onGradeChanged(payload);
                break;
            case 'ChangedSubjectPayload':
                this.onSubjectChanged(payload);
                break;
            case 'SelectedTemplatePayload':
                this.onTemplateSelected(payload);
                break;
            case 'UnselectedTemplatePayload':
                this.onTemplatesUnselected(payload);
                break;
            case 'StartedLoadingPayload':
                this.onLoadingStarted();
                break;
            case 'FinishedLoadingPayload':
                this.onLoadingFinished();
                break;
            case 'WorkTemplateErrorPayload':
                this.onWorkTemplateError();
                break;
            default:
                break;
        }
    };
    /**
     * 初期化
     */
    WorkTemplateTabState.prototype.onInitialized = function (_a) {
        var drillTypes = _a.drillTypes, grade = _a.grade, subject = _a.subject, courseList = _a.courseList, templateGroups = _a.templateGroups;
        if (templateGroups == null) {
            this.templateGroups.clear();
        }
        else {
            this.templateGroups = templateGroups;
        }
        this.drillTypes = drillTypes;
        this.grade = grade;
        this.subject = subject;
        this.courseList = courseList;
        this.isLoading = false;
        this.hasError = false;
        this.initialized = true;
    };
    /**
     * ワークテンプレートグループ一覧を取得
     */
    WorkTemplateTabState.prototype.onWorkTemplateGroupsLoaded = function (_a) {
        var templateGroups = _a.templateGroups;
        this.updateTemplateGroups(templateGroups);
    };
    /**
     * 学年を変更
     */
    WorkTemplateTabState.prototype.onGradeChanged = function (_a) {
        var grade = _a.grade, drillTypes = _a.drillTypes;
        this.grade = grade;
        this.drillTypes = drillTypes;
    };
    /**
     * 教科を変更
     */
    WorkTemplateTabState.prototype.onSubjectChanged = function (_a) {
        var subject = _a.subject, drillTypes = _a.drillTypes;
        this.subject = subject;
        this.drillTypes = drillTypes;
    };
    /**
     * テンプレートを選択
     */
    WorkTemplateTabState.prototype.onTemplateSelected = function (_a) {
        var templateGroups = _a.templateGroups;
        this.updateTemplateGroups(templateGroups);
    };
    /**
     * テンプレートの選択を解除
     */
    WorkTemplateTabState.prototype.onTemplatesUnselected = function (_a) {
        var templateGroups = _a.templateGroups;
        this.updateTemplateGroups(templateGroups);
    };
    /**
     * ロード開始
     */
    WorkTemplateTabState.prototype.onLoadingStarted = function () {
        this.hasError = false;
        this.isLoading = true;
    };
    /**
     * ロード終了
     */
    WorkTemplateTabState.prototype.onLoadingFinished = function () {
        this.isLoading = false;
    };
    /**
     * エラー発生
     */
    WorkTemplateTabState.prototype.onWorkTemplateError = function () {
        this.hasError = true;
    };
    /**
     * ワークテンプレートグループを更新
     */
    WorkTemplateTabState.prototype.updateTemplateGroups = function (templateGroups) {
        this.templateGroups.set(this.currentTemplateGroupsKey, templateGroups);
    };
    return WorkTemplateTabState;
}(State));
export var initialWorkTemplateTabState = new WorkTemplateTabState();
